import { gql } from '@apollo/client'
import { PageInfoFragment } from '@src/graphql/fragment/pageInfo'
import { PlanetMiddleLiteFragment } from '@src/graphql/fragment/planet'

export default gql`
  query GetMyPlanetsMiddleLite(
    $isBookmarked: Boolean!
    $filterInput: GetPlanetsFilterInput!
    $pagingInput: PagingInput
    $sortInput: PlanetSortInput!
  ) {
    getMyPlanets(
      isBookmarked: $isBookmarked
      filterInput: $filterInput
      pagingInput: $pagingInput
      sortInput: $sortInput
    ) {
      edges {
        cursor
        node {
          ...PlanetMiddleLite
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }

  ${PlanetMiddleLiteFragment}
  ${PageInfoFragment}
`
